import Vue from '@triotech/vue-core/src/vendor/vue';

// vue global mixin
Vue.mixin({
  filters: {
    formatCountryCode(value) {
      const indexOf = value.indexOf('_');
      return indexOf > 0 ? value.slice(0, indexOf) : value;
    },
  },
});
